import { promptInstall, useInstallStore } from './install-store';
import type { InstallPlatform } from './install';

export interface InstallPrompt {
  /** The browser has offered a prompt and a button of ours can open it. */
  canPrompt: boolean;
  /** Open the browser's install dialog. */
  promptInstall: typeof promptInstall;
  /** Already the installed app, or installed during this session. */
  installed: boolean;
  /** This page IS the installed app. */
  standalone: boolean;
  platform: InstallPlatform;
}

/**
 * What a component needs to offer an install. The signals themselves are
 * captured before render by `listenForInstallSignals` - see the store for
 * why - so this is a view of the store, nothing more.
 */
export function useInstallPrompt(): InstallPrompt {
  const deferredPrompt = useInstallStore((s) => s.deferredPrompt);
  const installed = useInstallStore((s) => s.installed);
  const standalone = useInstallStore((s) => s.standalone);
  const platform = useInstallStore((s) => s.platform);
  return { canPrompt: deferredPrompt !== null, promptInstall, installed, standalone, platform };
}
